import React from "react";

import StandingTable from "../../football/league/Standings";
import LeagMainHead from "../../common/LeagMainHead";
import TopScorers from "../../common/TopScorers";
import LeaguePage from "../../football/league/LeaguePage";
import News from "../../common/News";
import LeagueWrapper from "../../football/league/LeagueWrapper";
import InfoPage from "../../football/league/InfoPage";
import FootballLeagueStats from "../../football/league/FootballLeagueStats";
import LeagueTeamWrapper from "../../football/league/LeagueTeamWrapper";
import LeagueTable from "../../football/league/LeagueTable";

const LeagueWidgetWrap = ({
  dataId,
  dataType,
  sport,
  difference,
  head,
  data,
  headData,
  otherData,
  baseUrl,
  loadCSS,
  setDataId,
  setDataType,
  setHead,
  setLeagueId,
  setDate,
  date,
  setIsLive,
  isLive,
  dataSSR,
  dataClient = false,
  websiteBaseUrl,
  dataPath,
  dataTitle,
  liveCentre = false,
}) => {
  const renderWithHead = (tab, Component, componentProps = {}) => {
    return head ? (
      <LeagMainHead
        id={dataId}
        headData={headData}
        baseUrl={baseUrl}
        type="leagues"
        dataClient={dataClient}
        currentTab={tab}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        widgetTitle={dataTitle}
      >
        <Component {...componentProps} />
      </LeagMainHead>
    ) : (
      <Component {...componentProps} title={dataTitle} />
    );
  };

  switch (dataType) {
    // Self-contained modern standings widget (own header, no <Head> wrap, no Home/Away tabs).
    case "detailed-league-table":
      return (
        <LeagueTable
          variant="detailed"
          serverData={data}
          dataId={dataId}
          baseUrl={baseUrl}
          sport={sport}
          loadCSS={loadCSS}
          dataClient={dataClient}
        />
      );

    // Compact preview — first group, top 5 rows with pagination.
    case "preview-league-table":
      return (
        <LeagueTable
          variant="preview"
          serverData={data}
          dataId={dataId}
          baseUrl={baseUrl}
          sport={sport}
          loadCSS={loadCSS}
          dataClient={dataClient}
        />
      );

    case "league-standings":
      return renderWithHead("table", StandingTable, {
        data:
          data?.data?.football_tournament_tables ||
          data?.football_tournament_tables,
        loadCSS,
        dataClient,
      });

    case "league-top-scorers":
      return renderWithHead("top_scorers", TopScorers, {
        data: data?.data,
        loadCSS,
        dataClient,
      });

    case "league-news":
      return renderWithHead("news", News, {
        data,
        difference,
        loadCSS,
        dataClient,
        baseUrl,
        id: dataId,
        newsType: "league",
      });

    case "league-upcoming":
      return renderWithHead("upcoming", LeagueWrapper, {
        sport,
        data: data?.data,
        loadCSS,
        baseUrl,
        setDataType,
        setDataId,
        setHead,
        dataClient,
        websiteBaseUrl,
        dataPath,
        updatedData: true,
        difference,
      });
    case "league-results":
    case "league-finished":
      return renderWithHead("results", LeagueWrapper, {
        sport,
        data: data?.data,
        loadCSS,
        baseUrl,
        setDataType,
        setDataId,
        setHead,
        dataClient,
        websiteBaseUrl,
        dataPath,
        updatedData: true,
        difference,
      });

    case "league-stats":
      return renderWithHead("stats", FootballLeagueStats, {
        sport,
        data,
        loadCSS,
        baseUrl,
        setDataType,
        setDataId,
        setHead,
        dataClient,
        websiteBaseUrl,
        dataPath,
      });

    case "league-info":
      return renderWithHead("info", InfoPage, {
        id: dataId,
        sport,
        data,
        loadCSS,
        baseUrl,
        setDataType,
        setDataId,
        setHead,
        dataClient,
        websiteBaseUrl,
        dataPath,
      });

    case "league-teams":
      return renderWithHead("teams", LeagueTeamWrapper, {
        id: dataId,
        sport,
        data,
        loadCSS,
        baseUrl,
        setDataType,
        setDataId,
        setHead,
        dataClient,
        websiteBaseUrl,
        dataPath,
      });

    case "league-page":
      return head ? (
        <LeagMainHead
          id={dataId}
          imgUrl={`https://cms.cyberstate-tech.com/api/v1/public/assets/images/flags/country_${headData?.football_category?.fid}.png`}
          title={headData?.nm}
          type="leagues"
        >
          <LeaguePage
            data={data?.data}
            baseUrl={baseUrl}
            dataType={dataType}
            difference={difference}
            sport={sport}
            dataId={dataId}
            loadCSS={loadCSS}
            headData={headData}
            type="leagues"
            setDataId={setDataId}
            setDataType={setDataType}
            setHead={setHead}
          />
        </LeagMainHead>
      ) : (
        <LeaguePage
          data={data?.data}
          baseUrl={baseUrl}
          dataType={dataType}
          difference={difference}
          sport={sport}
          dataId={dataId}
          loadCSS={loadCSS}
          setDataId={setDataId}
          setDataType={setDataType}
          setHead={setHead}
        />
      );

    default:
      return <h1>Widget Not Found in football League!</h1>;
  }
};

export default LeagueWidgetWrap;
